import React, { useState, useRef, useEffect } from 'react';
import { TextField, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormContainer from '../../components/FormContainer';
import { addState, updateState } from '../../utils/api';

const StateForm = ({ editState = null, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const isEditMode = !!editState;
  const onSuccessTimerRef = useRef(null);

  useEffect(
    () => () => {
      if (onSuccessTimerRef.current != null) {
        clearTimeout(onSuccessTimerRef.current);
        onSuccessTimerRef.current = null;
      }
    },
    []
  );

  const validationSchema = Yup.object({
    stateName: Yup.string().required('State name is required').max(100, 'State name must be at most 100 characters'),
  });

  const formik = useFormik({
    initialValues: {
      stateName: editState ? editState.stateName : '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      setSuccessMessage(null);
      setErrorMessage(null);

      try {
        if (isEditMode) {
          await updateState(editState.stateId, values, {
            previousData: editState,
            identifier: editState.stateName || values.stateName
          });
          setSuccessMessage('State updated successfully!');
        } else {
          await addState(values, {
            identifier: values.stateName
          });
          setSuccessMessage('State added successfully!');
          resetForm();
        }
        
        if (onSuccess) {
          if (onSuccessTimerRef.current != null) clearTimeout(onSuccessTimerRef.current);
          onSuccessTimerRef.current = setTimeout(() => {
            onSuccessTimerRef.current = null;
            onSuccess();
          }, 1500);
        }
      } catch (error) {
        console.error(`Error ${isEditMode ? 'updating' : 'adding'} state:`, error);
        setErrorMessage(error.response?.data?.message || `Failed to ${isEditMode ? 'update' : 'add'} state. Please try again.`);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const handleCloseSnackbar = () => {
    setSuccessMessage(null);
    setErrorMessage(null);
  };

  return (
    <FormContainer
      title={isEditMode ? "Edit State" : "Add State"}
      onSubmit={formik.handleSubmit}
      isSubmitting={isSubmitting}
      successMessage={successMessage}
      errorMessage={errorMessage}
      onCloseSnackbar={handleCloseSnackbar}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="stateName"
            name="stateName"
            label="State Name"
            value={formik.values.stateName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.stateName && Boolean(formik.errors.stateName)}
            helperText={formik.touched.stateName && formik.errors.stateName}
            margin="normal"
            variant="outlined"
          />
        </Grid>
      </Grid>
    </FormContainer>
  );
};

export default StateForm; 